import { Row, Col } from 'antd';
import {
  FormItem,
  ControlledInputWithTooltip,
} from 'modules/common/components';
import { ControlledYesNoRadioGroup } from 'modules/donor/components';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { getTranslation } from 'utils/getTranslation';

import { PetMicrochipField } from './fields';

const t = getTranslation('donor.EditDonorForm.DonorMicrochipSection');

type PropTypes = {
  fieldNamePrefix: string;
  disabled?: boolean;
};

const DonorMicrochipSection: FC<PropTypes> = ({
  fieldNamePrefix,
  disabled,
}) => {
  const { control, watch, formState, getFieldState } = useFormContext();

  const getFieldName = (fieldName: PetMicrochipField) => {
    return `${fieldNamePrefix}.${fieldName}`;
  };
  const hasMicrochip = watch(getFieldName(PetMicrochipField.hasMicrochip)) as
    | boolean
    | undefined;
  const microchipNumber = watch(getFieldName(PetMicrochipField.chipNo)) as
    | number
    | undefined;

  const chipNoFieldName = getFieldName(PetMicrochipField.chipNo);

  const { error: microchipNumberError } = getFieldState(
    chipNoFieldName,
    formState
  );

  return (
    <Row>
      <Col span={24}>
        <FormItem label={t('hasMicrochip')}>
          <ControlledYesNoRadioGroup
            controlled={{
              control,
              name: getFieldName(PetMicrochipField.hasMicrochip),
            }}
            disabled={disabled}
          />
        </FormItem>
      </Col>
      {(hasMicrochip || microchipNumber) && (
        <Col span={24}>
          <FormItem
            label={t('microchipNo')}
            extra={microchipNumberError?.message}
            validateStatus={microchipNumberError ? 'error' : undefined}
          >
            <ControlledInputWithTooltip
              controlled={{ control, name: chipNoFieldName }}
              disabled={disabled}
            />
          </FormItem>
        </Col>
      )}
    </Row>
  );
};

export default DonorMicrochipSection;
